import { Box } from '@mui/material';
import { NavLink, useParams, useSearchParams } from 'react-router';

const ITEMS = [
  { path: 'columns', label: 'Column access' },
  { path: 'report-templates', label: 'Report templates' },
] as const;

export default function ParentAnalyticsAccessSubNav() {
  const { accountId, childClientId } = useParams<{
    accountId: string;
    childClientId: string;
  }>();
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const searchSuffix = search ? `?${search}` : '';

  const basePath = `/client/${accountId ?? ''}/account/child-accounts/${
    childClientId ?? ''
  }/analytics-access`;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
        borderBottom: 1,
        borderColor: 'divider',
        width: '100%',
        mb: 2,
      }}
    >
      <Box
        component="nav"
        aria-label="Analytics access sections"
        sx={{ display: 'flex', flexWrap: 'wrap', flex: 1 }}
      >
        {ITEMS.map(({ path, label }) => (
          <Box
            key={path}
            component={NavLink}
            to={`${basePath}/${path}${searchSuffix}`}
            end
            sx={{
              fontWeight: 600,
              fontSize: '0.875rem',
              px: 2,
              py: 1,
              textDecoration: 'none',
              color: 'text.secondary',
              borderBottom: '2px solid transparent',
              marginBottom: '-2px',
              transition: 'color 150ms, border-color 150ms',
              '&:hover': {
                color: 'text.primary',
              },
              '&.active': {
                color: 'primary.main',
                borderBottomColor: 'primary.main',
              },
            }}
          >
            {label}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
